export const EXPIRATION_OPTIONS = [
  { label: 'In 30 days', value: 30 },
  { label: 'In 60 days', value: 60 },
  { label: 'In 90 days', value: 90 },
  { label: 'In 6 months', value: 180 },
  { label: 'Never expire', value: 0 },
];
